import { Section8Images } from '../../../assets/OurStoryImages/Section8'

const body5Styles =
  'text-xs text-[#37455C] font-normal leading-4 tracking-[0.4px] xl:text-sm 2xl:text-base 3xl:text-2xl'
const title5StylesA = 'text-sm font-medium text-[#37455C] xl:text-base 2xl:text-lg 3xl:text-[32px] 3xl:py-10'
const title5StylesB = 'text-sm font-medium text-[#001A3D] pb-3 xl:text-base 3xl:text-lg 3xl:text-2xl'
const imgStyles = 'w-full lg:h-[380px] 2xl:h-[554px]'

// The following styles are used to create border gradients
const bgGradientStyles =
  'bg-gradient-to-r from-[#24547C] from-0% via-[#38a8c3] via-20% to-[#3DC3D8] to-100%'
const borderLeftBottomStyles = 'pl-[1px] pb-[3px] rounded-bl-[10px]'
const borderRightBottomStyles = 'pr-[1px] pb-[3px] rounded-br-[10px]'
const bgGradientCoverStyles = 'bg-white w-full h-full p-6' // used to cover most of the bg gradient

export const Section8 = () => {
  return (
    <div className='!p-15 mb-11 bg-white rounded-[20px] border border-[#EBF3FF] shadow-[12px_0px_40px_0px_rgba(0,26,61,0.20)] space-y-5 lg:w-[860px] 2xl:w-[1260px] 2xl:!p-20 3xl:w-[1760px] 3xl:!p-30'>
      <h1 className='text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-[64px] text-[#001A3D] font-bold leading-8'>
        Our impact
      </h1>
      <p className={title5StylesA}>
        Empowering 100,000s of individuals to access the legal support they
        need.
      </p>
      <p className={body5Styles}>
        At Legal Utopia, our mission is to get the legal professions to work for
        everyone and our technology is bridging the gap between individuals and
        lawyers. Since 2023, we have been empowering over 100,000 people a year
        to navigate their personal and professional legal life events with our
        services, technology, and pathways to law providing confidence and
        clarity.
      </p>
      <div className='flex justify-center items-center lg:py-20 2xl:py-30'>
        <div className='flex flex-col gap-5 py-20 lg:flex-row lg:w-[562px] lg:h-[380px] lg:py-1 2xl:w-[818px] 2xl:h-[554px]'>
          <img
            src={Section8Images.OurImpactPhone1}
            alt='Our Impact Phone 1'
            className={imgStyles}
          />
          <img
            src={Section8Images.OurImpactPhone2}
            alt='Our Impact Phone 2'
            className={imgStyles}
          />
          <img
            src={Section8Images.OurImpactPhone3}
            alt='Our Impact Phone 3'
            className={imgStyles}
          />
        </div>
      </div>
      <p className={body5Styles}>
        Through our AI-powered platform, our customers can:
      </p>
      <div className='flex flex-col gap-0 pb-20'>
        <div className={`${bgGradientStyles} ${borderLeftBottomStyles}`}>
          <div
            className={`${bgGradientCoverStyles} -mt-[1px] ml-[1px] rounded-bl-lg`}
          >
            <h5 className={title5StylesB}>Identify legal issues:</h5>
            <p className={body5Styles}>
              Our novel AI-method creates a safe and reliable way for people to
              self-diagnose their legal matter by describing it in their own
              words.
            </p>
          </div>
        </div>
        <div className={`${bgGradientStyles} ${borderRightBottomStyles}`}>
          <div
            className={`${bgGradientCoverStyles} -mt-[1px] -ml-[1px] rounded-br-lg text-right`}
          >
            <h5 className={title5StylesB}>Access resources:</h5>
            <p className={body5Styles}>
              We provide personalised recommendations and resources to address
              specific legal events and get the right information to our
              customers when they need it.
            </p>
          </div>
        </div>
        <div className={`${bgGradientStyles} ${borderLeftBottomStyles}`}>
          <div
            className={`${bgGradientCoverStyles} -mt-[1px] ml-[1px] rounded-bl-lg`}
          >
            <h5 className={title5StylesB}>Connect with legal professions:</h5>
            <p className={body5Styles}>
              Our online Find a Lawyer service means that people can easily find
              qualified, verified and relevant lawyers whose expertise, location
              and price fit their needs.
            </p>
          </div>
        </div>
      </div>
      <p className={body5Styles}>
        By leveraging technology, we’ve made legal services more accessible,
        affordable, and transparent. Our commitment to explore new pathways to
        the legal professions has enabled us to help people to access legal
        advice and support more quickly without the stress and confusion
        previously associated with finding a lawyer when you need one.
      </p>
    </div>
  )
}
